export const loanSizerTypeEnums = {
  HANDSOME_HOME_BUYER: "handsomeHomebuyer",
};
